import * as yup from 'yup';

export const FeedbackValidationSchema = yup.object().shape({
	clientName: yup.string().required('Client name and surname is required'),
	analystName: yup.string().required('Analyst name and surname is required'),
	isSatisfied: yup.boolean().nullable().required('Please indicate if you were satisfied with your verification result'),
	isRequirementsUnderstood: yup.boolean().nullable().required('Please indicate if the verification analyst understood your organisations BBBEE Requirements'),
	isProfessional: yup.boolean().nullable().required('Please indicate if the verification analyst conducted themselves in a professional manner at all times'),
	analystRating: yup.number().typeError('Please indicate how would you rate your experience').nullable(true).transform((value, originalValue) => {
			if (originalValue === '') {
				return null;
			}
			return value;
		}).required('Please indicate how would you rate your experience'),
	premierRating: yup.number().typeError('Please indicate how would you rate your experience').nullable(true).transform((value, originalValue) => {
			if (originalValue === '') {
				return null;
			}
			return value;
		}).required('Please indicate how would you rate your experience'),
	wouldRefer: yup.boolean().nullable().required('Please indicate if you would refer the Verification Agency`s services to anyone else'),

	reason: yup.string().when('isSatisfied', {
		is: (isSatisfied: boolean) => isSatisfied === false,
		then: yup.string().required("Reason is required").max(1000, 'Must be less than 1000 characters'),
		otherwise: yup.string().nullable()
	}),
	improvementFeedback: yup.string().nullable().max(1000, 'Must be less than 1000 characters')
});


export const FeedbackValidationEmailSchema = yup.object().shape({
	EmailTo: yup
		.array()
		.of(yup.string().required())
		.min(1, 'Contact is required'),
});